import request from '@utils/fetch'

// 查询 游戏界面勾选状态
export function getQuizConfState(data) {
  return request({
    url: '/quizConf/getQuizConfState',
    method: 'post',
    params: data
  })
}

// 查询 游戏配置项 单词选项
export function getConfData(data) {
  return request({
    url: '/quizConf/getConfData',
    method: 'post',
    data
  })
}

// 查询 游戏配置 干扰项
export function getQuizConfInterferes(data) {
  return request({
    url: '/quizConf/getQuizConfInterferes',
    method: 'post',
    data
  })
}

// 阅读 和 句型 模块  句型选择 将图片和句子 一对一保存接口
export function saveSentenceGroupConf(data) {
  return request({
    url: '/quizConf/saveSentenceGroupConf',
    method: 'post',
    data
  })
}

// 保存 配置 干扰项 (重构之后统一成 一个接口)
export function saveConfData(data) {
  return request({
    url: '/quizConf/saveConfData',
    method: 'post',
    data
  })
}

// 单词：保存 配置 干扰项
export function saveConfWords(data) {
  return request({
    url: '/quizConf/saveConfWords',
    method: 'post',
    data
  })
}

// 高频词：保存 配置 干扰项
export function saveConfSightWords(data) {
  return request({
    url: '/quizConf/saveConfSightWords',
    method: 'post',
    data
  })
}

// 阅读：保存 配置 干扰项
export function saveConfReading(data) {
  return request({
    url: '/quizConf/saveConfReading',
    method: 'post',
    data
  })
}

// 自然拼读：保存 配置 干扰项
export function saveConfPhonics(data) {
  return request({
    url: '/quizConf/saveConfPhonics',
    method: 'post',
    data
  })
}

// 句型：保存 配置 干扰项
export function saveConfSentence(data) {
  return request({
    url: '/quizConf/saveConfSentence',
    method: 'post',
    data
  })
}

// 保存 游戏 （最后一步）
export function saveQuiz(data) {
  return request({
    url: '/quizConf/saveQuiz',
    method: 'post',
    data
  })
}

// 单词模块-图文连线游戏 配置项 保存
export function saveConfGraphicConnection(data) {
  return request({
    url: '/quizConf/saveConfGraphicConnection',
    method: 'post',
    data
  })
}

